import TourContainer from "../../Componant/BonusUI/Tour";

const Tour = () => {
  return (
    <div className="page-body">
      <TourContainer />
    </div>
  );
};

export default Tour;
